import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';


@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styles: []
})
export class FooterComponent implements OnInit {

	version:string = environment.VERSION;
	date:Date = new Date();
	year = this.date.getFullYear();

	constructor() { }

	ngOnInit(): void {}

}
